module.exports = __webpack_public_path__ + "15b4359c26e5cd2424dc95cea6113c01.webp";